module.exports = __webpack_public_path__ + "static/1-729652273663f77a704d2a0b3fb08f2e.jpg";